export class SessionKeys {

    public static languageObj = 'languageObj';
    public static languageName = 'languageName';
    public static languageList = 'languageList';
    public static loginObj = 'loginObj';
    public static autho_token = 'autho_token';
    public static socialLink = 'socialLink';
    public static homeData = 'homeData';
    public static dashboardData = 'dashboardData';
    public static previousMenu = 'previousMenu';
    public static fetchedTime = 'fetchedTime';
    public static productObj = 'productObj';

}
